"use client";

import { useEffect } from "react";

export function useNavigationEvent(onBack: () => void): void {
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (event.state?.navigationType === "back" || !event.state) {
        onBack();
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [onBack]);
}
